<template>
	<div class="center_main_box">
		<main-top></main-top>
		<!-- 订单状态 -->
		<!-- v-if="!power.includes(111) && character_id !== 5 && character_id !== 6" -->
		<div class="center_main_order" v-if="power.includes(0) || power.includes(11)">
			<main-title :learn-more="() => $router.push('/center/orderStatus')" :title="$t('message.cmain.title1')">
			</main-title>
			<main-order :msg="examine_status"
				:num="[order_num.order0,order_num.order1,order_num.order2,order_num.order3,order_num.order4,order_num.order5,order_num.order8]">
			</main-order>
		</div>
		<!-- 支付状态 -->
		<!-- v-if="character_id !== 5 && character_id !== 6" -->
		<div class="center_main_order" v-if="power.includes(0) || power.includes(12) || power.includes(111)">
			<main-title :learn-more="() => $router.push('/center/payStatus')" :title="$t('message.cmain.title2')">
			</main-title>
			<main-order :msg="order_status"
				pagePath=1
				:num="[order_num.pay0,order_num.pay1,order_num.pay2,order_num.pay3]">
			</main-order>
		</div>
		<!-- 我的商品 -->
		<!-- v-if="power.includes(0) || character_id==2 || character_id==3" -->
		<div class="center_main_order" v-if="power.includes(0) || power.includes(16)">
			<main-title :learn-more="() => $router.push('/center/goods')" :title="$t('message.cmain.title3')">
			</main-title>
			<main-goods></main-goods>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'

	export default {
		data() {
			return {
				succ: 0, // 加载成功数量
				examine_status: [{
						img: "order@2x.png",
						title: this.$t("message.cmain.status9"),
						position: "9",
					},
					{
						img: "untreated.png",
						title: this.$t("message.cmain.status1"),
						position: "0",
					},
					{
						img: "pass.png",
						title: this.$t("message.cmain.status2"),
						position: "1",
					},
					{
						img: "cancel.png",
						title: this.$t("message.cmain.status3"),
						position: "2",
					},
					{
						img: "modify.png",
						title: this.$t("message.cmain.status4"),
						position: "3",
					},
					{
						img: "finish.png",
						title: this.$t("message.cmain.status5"),
						position: "4",
					},
					{
						img: "return.png",
						title: this.$t("message.cmain.status8"),
						position: "7",
					},
				], // 订单状态
				order_status: [
					{
						img: "order@2x.png",
						title: this.$t("message.cmain.status9"),
						position: "9",
					},
					{
						img: "wallet.png",
						title: this.$t("message.cmain.status10"),
						position: "0",
					},
					{
						img: "paid@2x.png",
						title: this.$t("message.cmain.status11"),
						position: "20",
					},
					{
						img: "pay.png",
						title: this.$t("message.cmain.status12"),
						position: "30",
					},
				], // 支付状态
			}
		},
		computed: mapState({
			islogin: state => state.user.islogin,
			order_num: state => state.user.order_num,
			character_id: state => state.user.character_id,
			power: state => state.user.power
		}),
		components: {
			mainTop: () => import("@/components/center/mainTop"),
			mainTitle: () => import("@/components/center/mainTitle"),
			mainOrder: () => import("@/components/center/mainOrder"),
			mainGoods: () => import("@/components/center/mainGoods"),
		},
		methods: {
			...mapMutations([
				"handleLoading",
				"clearCenterMain",
				"setCenterMainGoods"
			]),
			...mapActions([
				"getCenterMainInfo",
				"getCenterMainOrder",
				"getCenterMainGoods",
			])
		},
		watch: {
			succ(val) {
				let allow = this.power.includes(111) || this.character_id == 4 || this.character_id == 5 || this
					.character_id == 6;
				if (allow && val == 2 || val == 3) {
					this.handleLoading(false)
				}
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				if (vm.islogin) {
					vm.succ = 0;
					vm.handleLoading(true); // 开启加载动画
					vm.getCenterMainInfo().then((res) => {
						if (res)
							vm.succ += 1;
					});
					vm.getCenterMainOrder().then((res) => {
						if (res)
							vm.succ += 1;
					});
					// let allow = vm.power.includes(0) || vm.character_id==2 || vm.character_id==3;
					setTimeout(() => {
						// let allow = vm.power.includes(0) || vm.power.includes(16);
						let allow = true;
						if (allow) {
							vm.getCenterMainGoods().then((res) => {
								if (res)
									vm.succ += 1;
							});
						}
					}, 500)
				} else {
					vm.$confirm(vm.$t("public.notLogin"), {
						confirmButtonText: vm.$t("public.goLogin"),
						cancelButtonText: vm.$t("public.cancelBtn"),
						type: 'warning'
					}).then(() => {
						vm.$router.push("/login")
					}).catch(() => {
						vm.$router.push("/main")
					})
				}
			})
		},
		beforeRouteLeave(to, from, next) {
			// ...
			this.clearCenterMain();
			this.setCenterMainGoods([]);
			next();
		}
	}
</script>

<style scoped>
	/* 组件盒子 */
	.center_main_box {
		width: 100%;
	}

	/* 订单审批盒子 */
	.center_main_order {
		margin-top: 30px;
		background: #fff;
	}
</style>
